/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { CompanyFragmentFragmentDoc } from './companyFragment.generated';
import { CompanyServicesFragmentFragmentDoc } from './companyServicesFragment.generated';
import { SocialTagsFragmentFragmentDoc } from './socialTagsFragment.generated';
import { AdditionalCompanyInfoFragmentFragmentDoc } from './additionalCompanyInfoFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Brand_Enum =
  /** G20 */
  | 'G20'
  /** Auchan Hyper */
  | 'auchan_hyper'
  /** Auchan MyAuchan */
  | 'auchan_myauchan'
  /** Auchan Super */
  | 'auchan_super'
  /** Biocoop */
  | 'biocoop'
  /** Carrefour City */
  | 'carrefour_city'
  /** Carrefour Contact */
  | 'carrefour_contact'
  /** Carrefour Express */
  | 'carrefour_express'
  /** Carrefour Hyper */
  | 'carrefour_hyper'
  /** Carrefour Market */
  | 'carrefour_market'
  /** Coccimarket */
  | 'coccimarket'
  /** Coccimarket City */
  | 'coccimarket_city'
  /** Coccimarket Easy */
  | 'coccimarket_easy'
  /** Cora */
  | 'cora'
  /** Diago */
  | 'diago'
  /** E.Leclerc */
  | 'e_leclerc'
  /** E.Leclerc Express */
  | 'e_leclerc_express'
  /** Franprix */
  | 'franprix'
  /** Hyper U */
  | 'hyper_u'
  /** Intermarché Contact */
  | 'intermarche_contact'
  /** Intermarché Express */
  | 'intermarche_express'
  /** Intermarché Hyper */
  | 'intermarche_hyper'
  /** Intermarché Super */
  | 'intermarche_super'
  /** Monop’ */
  | 'monop'
  /** Monoprix */
  | 'monoprix'
  /** Netto */
  | 'netto'
  /** Sitis Market */
  | 'sitis_market'
  /** Spar */
  | 'spar'
  /** Super U */
  | 'super_u'
  /** U Express */
  | 'u_express'
  /** Utile */
  | 'utile';

export type Business_Profile_Enum =
  | 'BUYER'
  | 'SUPPLIER';

export type Marketing_Support_Enum =
  | 'FURNITURE'
  | 'OTHER'
  /** English acronym for 'PLV' */
  | 'POS';

export type Minimum_Order_Value_Type_Enum =
  | 'PACKAGING'
  | 'PRICE'
  | 'WEIGHT';

export type Return_Policy_Enum =
  | 'FULL'
  | 'PARTIAL';

export type Social_Tag_Type_Enum =
  | 'ENGAGED_STORE'
  | 'GUARANTEED_SALES'
  | 'HIDDEN_GEM'
  | 'HIGHLY_RESPONSIVE'
  | 'HIGH_MARGIN'
  | 'NEW_ARRIVAL'
  | 'POPULAR'
  | 'TREND';

export type CompanyByIdQueryVariables = Exact<{
  companyId: string;
  getProductSubFamilies?: boolean;
}>;


export type CompanyByIdQuery = { company_by_pk: { contactEmail: string, business_profile: Types.Business_Profile_Enum, contactPhoneNumber: string, description: string | null, id: string, is_wholesaler: boolean, national_company_registration_number: string, legalName: string, invoice_prefix: string, tradeName: string, brand: Types.Brand_Enum | null, provide_marketing: boolean | null, marketing_details: string | null, provide_animation: boolean | null, animation_details: string | null, provide_electrical_appliance: boolean | null, electrical_appliance_details: string | null, provide_return_policy: boolean | null, return_policy: Types.Return_Policy_Enum | null, return_policy_details: string | null, provide_merchandising: boolean | null, merchandising_details: string | null, delivery_description: string | null, delivery_instructions: string | null, delivery_email: string | null, delivery_phone_number: string | null, invoicing_instructions: string | null, invoicing_email: string | null, invoicing_phone_number: string | null, addresses: Array<{ administrativeAreaLevel2: string | null, formattedAddress: string, latitude: number, longitude: number, locality: string | null, postalTown: string | null, countryCode: string, postalCode: string | null }>, role_assignments: Array<{ userId: string, is_delivery_contact: boolean, is_invoicing_contact: boolean, user: { id: string, first_name: string, last_name: string, auth_provider_avatar_url: string | null, default_avatar: { path: string, domain: string | null } | null } }>, social_tags: Array<{ id: string, level: number, priority: number, type: Types.Social_Tag_Type_Enum, values: { [key: string]: any } | null }>, photos: Array<{ photo: { path: string, domain: string | null } }>, marketing_supports: Array<{ support: Types.Marketing_Support_Enum }>, delivery_zones: Array<{ id: string, index: number, minimum_order_value: number, minimum_order_value_type: Types.Minimum_Order_Value_Type_Enum, negotiable_minimum_order_value: boolean, delivery_time: number | null, administrative_areas: Array<{ area: string }> }>, delivery_hours: Array<{ id: string, opening_hour: string, closing_hour: string, week_day: string }>, delivery_address: { id: string, address_1: string, address_2: string | null, postal_code: string, city: string, country: string, name: string } | null, invoicing_address: { id: string, address_1: string, address_2: string | null, postal_code: string, city: string, country: string, name: string } | null } | null, company_product_count_by_sub_family?: Array<{ company_id: string, count: number, sub_family: string }> };


export const CompanyByIdDocument = /*#__PURE__*/ gql`
    query companyById($companyId: uuid!, $getProductSubFamilies: Boolean! = false) {
  company_by_pk(id: $companyId) {
    ...companyFragment
    ...companyServicesFragment
    addresses {
      administrativeAreaLevel2
      formattedAddress
      latitude
      longitude
      locality
      postalTown
      countryCode
      postalCode
    }
    contactEmail
    business_profile
    contactPhoneNumber
    description
    id
    is_wholesaler
    national_company_registration_number
    legalName
    invoice_prefix
    role_assignments(distinct_on: [userId]) {
      userId
      is_delivery_contact
      is_invoicing_contact
      user {
        id
        first_name
        last_name
        auth_provider_avatar_url
        default_avatar {
          path
          domain
        }
      }
    }
    social_tags(where: {base_unit_sku: {_is_null: true}}) {
      ...socialTagsFragment
    }
    ...additionalCompanyInfoFragment
  }
  company_product_count_by_sub_family(args: {company_id: $companyId}) @include(if: $getProductSubFamilies) {
    company_id
    count
    sub_family
  }
}
    ${CompanyFragmentFragmentDoc}
${CompanyServicesFragmentFragmentDoc}
${SocialTagsFragmentFragmentDoc}
${AdditionalCompanyInfoFragmentFragmentDoc}`;

/**
 * __useCompanyByIdQuery__
 *
 * To run a query within a React component, call `useCompanyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyByIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      getProductSubFamilies: // value for 'getProductSubFamilies'
 *   },
 * });
 */
export function useCompanyByIdQuery(baseOptions: Apollo.QueryHookOptions<CompanyByIdQuery, CompanyByIdQueryVariables> & ({ variables: CompanyByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyByIdQuery, CompanyByIdQueryVariables>(CompanyByIdDocument, options);
      }
export function useCompanyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyByIdQuery, CompanyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyByIdQuery, CompanyByIdQueryVariables>(CompanyByIdDocument, options);
        }
// @ts-ignore
export function useCompanyByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyByIdQuery, CompanyByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyByIdQuery, CompanyByIdQueryVariables>;
export function useCompanyByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyByIdQuery, CompanyByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyByIdQuery | undefined, CompanyByIdQueryVariables>;
export function useCompanyByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyByIdQuery, CompanyByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyByIdQuery, CompanyByIdQueryVariables>(CompanyByIdDocument, options);
        }
export type CompanyByIdQueryHookResult = ReturnType<typeof useCompanyByIdQuery>;
export type CompanyByIdLazyQueryHookResult = ReturnType<typeof useCompanyByIdLazyQuery>;
export type CompanyByIdSuspenseQueryHookResult = ReturnType<typeof useCompanyByIdSuspenseQuery>;
export type CompanyByIdQueryResult = Apollo.QueryResult<CompanyByIdQuery, CompanyByIdQueryVariables>;